"use client";

import { Instagram, Mail, Music2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Meetourexperts() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const craftsmen = [{
    name: "Charles Roets",
    role: "Co-Owner",
    bio: "Specializing in Siemens CNC systems and industrial automation, Charles brings decades of technical expertise to every complex repair.",
    chair: "UNIT 01",
    index: "01",
    image: {
      src: "https://suited-gecko-1.10web.cloud/wp-content/uploads/2026/06/20241204_1146370-EDIT-300x300-1.jpg?v=bt5mxmqsjg4",
      srcset: "https://suited-gecko-1.10web.cloud/wp-content/uploads/2026/06/20241204_1146370-EDIT-300x300-1.jpg?v=fdz47je2p5t-wvc-srcset",
      sizes: "https://suited-gecko-1.10web.cloud/wp-content/uploads/2026/06/20241204_1146370-EDIT-300x300-1.jpg?v=qv9zd26est-wvc-sizes",
      alt: "Portrait of Charles Marais, Lead Technical Engineer"
    },
    indexClassName: "relative aspect-[4/5] overflow-hidden bg-muted !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696316/img/manager_sarah_van_wyk.png)]"
  }, {
    name: "Johnny van Niekel",
    role: "Co-Owner",
    bio: "Johhny manages on-site diagnostics and field services, ensuring minimal downtime for our clients' industrial operations.",
    chair: "UNIT 02",
    index: "02",
    image: {
      src: "https://suited-gecko-1.10web.cloud/wp-content/uploads/2026/06/Johnny-150x150-1.jpg?v=mdiqcxbegv",
      srcset: "https://suited-gecko-1.10web.cloud/wp-content/uploads/2026/06/Johnny-150x150-1.jpg?v=sy6zvw8di3r-wvc-srcset",
      sizes: "https://suited-gecko-1.10web.cloud/wp-content/uploads/2026/06/Johnny-150x150-1.jpg?v=47k0jn5c0uq-wvc-sizes",
      alt: "Portrait of Johan Smit, Field Service Specialist"
    }
  }];
  return <section data-section-id="1587" id="meetourexperts" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 bottom-0 w-[60vw] h-[60vw] rounded-lg opacity-[0.08]" style={{
      background: "radial-gradient(circle at 30% 70%, hsl(178 65% 72% / 0.6) 0%, hsl(178 65% 72% / 0) 60%)"
    }} />

      <div className="relative max-w-[1440px] mx-auto px-8 md:px-12 lg:px-20">
        {}
        <div className="font-mono text-xs uppercase mb-12 md:mb-16" style={{
        letterSpacing: "0.16em",
        lineHeight: 1
      }}>
          <span className="text-primary">§</span>
          <span className="text-muted-foreground"> 04 · /engineering-team</span>
        </div>

        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="lg:col-span-7">
            <h2 className="font-default font-bold text-foreground" style={{
            fontSize: "clamp(2rem, 5vw, 4.25rem)",
            letterSpacing: "-0.03em",
            lineHeight: 1.0
          }}>
              The experts behind the{" "}
              <span className="inline-block align-baseline border rounded-md px-1.5" style={{
              borderColor: "hsl(178 65% 72%)",
              paddingTop: "0.05em",
              paddingBottom: "0.05em"
            }}>
                precision
              </span>
            </h2>
            <p className="mt-6 max-w-2xl text-muted-foreground font-default font-normal" style={{
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
            letterSpacing: "-0.005em",
            lineHeight: 1.55
          }}>A directory of the technical specialists at IMCNC Designs — combining deep Siemens expertise with industrial problem-solving.</p>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col justify-between gap-8">
            <p className="text-muted-foreground font-default font-normal" style={{
            fontSize: "1rem",
            lineHeight: 1.6
          }}>
              Every engineer is selected for their mastery of Siemens CNC systems and commitment to industrial excellence. 
              We provide 24/7 support and field services across Gauteng and beyond.
            </p>

            {}
            <div className="flex items-center gap-3">
              <span className="font-mono font-medium text-foreground" style={{
              fontSize: "0.8125rem",
              letterSpacing: "0.04em"
            }}>
                02
              </span>
              <span className="block w-12 h-px bg-border" />
              <span className="font-mono text-muted-foreground" style={{
              fontSize: "0.8125rem",
              letterSpacing: "0.16em"
            }}>CNC SPECIALISTS</span>
            </div>
          </div>
        </div>

        {}
        <div className="relative h-px w-full mb-16 md:mb-20 bg-border">
          <span className="absolute left-0 top-0 h-px w-24 bg-primary" />
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-7 justify-center">
          {craftsmen.map((person, i) => <article key={person.name} data-index={i} className={`group relative transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: gridVisible ? `${i * 80}ms` : "0ms"
        }}>
              {}
              <div className="relative border overflow-hidden rounded-md transition-colors duration-300 ease-out border-border">
                {}
                <span aria-hidden="true" className="absolute top-2 left-2 w-3 h-3 z-10 pointer-events-none transition-colors duration-300" style={{
              borderTop: "1px solid hsl(178 15% 89%)",
              borderLeft: "1px solid hsl(178 15% 89%)"
            }} />
                <span aria-hidden="true" className="absolute bottom-12 right-2 w-3 h-3 z-10 pointer-events-none transition-colors duration-300" style={{
              borderBottom: "1px solid hsl(178 15% 89%)",
              borderRight: "1px solid hsl(178 15% 89%)"
            }} />

                {}
                <span aria-hidden="true" className="absolute top-3 right-4 font-default font-bold pointer-events-none z-10 leading-none" style={{
              fontSize: "5rem",
              color: "hsl(178 65% 72% / 0.1)",
              letterSpacing: "-0.04em"
            }}>
                  {person.index}
                </span>

                {}
                <div className={`${person.indexClassName || ""} relative aspect-[4/5] overflow-hidden bg-muted`}>
                  <img src={person.image.src} data-wvc-srcset={person.image.srcset} data-wvc-sizes={person.image.sizes} alt={person.image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.03]" />
                </div>

                {}
                
              </div>

              {}
              <div className="mt-5">
                <h3 className="font-default font-bold text-foreground" style={{
              fontSize: "clamp(1.25rem, 1.8vw, 1.625rem)",
              letterSpacing: "-0.015em",
              lineHeight: 1.15
            }}>
                  {person.name}
                </h3>
                <h4 className="mt-1 font-default font-medium text-primary" style={{
              fontSize: "clamp(1rem, 1.3vw, 1.125rem)",
              letterSpacing: "-0.01em",
              lineHeight: 1.3
            }}>
                  {person.role}
                </h4>
                <p className="mt-3 text-muted-foreground font-default font-normal" style={{
              fontSize: "1rem",
              lineHeight: 1.6
            }}>
                  {person.bio}
                </p>

                {}
                
              </div>

              {}
              <style>{`
                article:hover > div:first-child { border-color: hsl(178 65% 72%) !important; }
              `}</style>
            </article>)}
        </div>
      </div>
    </section>;
}